<template>
  <div class="num-quantity">
    <Button
      icon="pi pi-minus"
      text
      rounded
      aria-label="decrease quantity"
      tabindex="-1"
      @click="changeQuantity(-1)"
      class="decrease-button flex-static"
      :disabled="props.modelValue < props.minValue"
    />
    <input
      v-model.number="value"
      class="quantity-input flex-stretch"
      aria-label="item quantity"
      :size="3"
      :min="1"
      :max="props.maxValue"
    />
    <Button
      icon="pi pi-plus"
      text
      rounded
      aria-label="increase quantity"
      tabindex="-1"
      @click="changeQuantity(+1)"
      class="increase-button flex-static"
      :disabled="!!props.maxValue && props.modelValue >= props.maxValue"
    />
  </div>
</template>

<script setup lang="ts">
import Button from "primevue/button";
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    modelValue: number;
    minValue?: number;
    maxValue?: number;
  }>(),
  { minValue: 0 },
);
const emits = defineEmits(["update:modelValue"]);

const value = computed<number>({
  get: () => props.modelValue,
  set: (v) => {
    if (v || v === 0) {
      emits("update:modelValue", v);
    }
  },
});

function changeQuantity(delta: number) {
  value.value += delta;
}
</script>

<style scoped>
.num-quantity {
  padding: 0px;
  gap: 0;
  margin: 0 0 var(--Sm, 24px) 0;
  min-width: 92px !important;
  flex: 0 0 auto;
  width: min-content;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
}
@media (max-width: 800px) {
  .num-quantity {
    border: 1px solid var(--30, #c4c4c4);
  }
}

.num-quantity :deep(.p-button-icon) {
  width: 7px;
  height: 7px;
}
.p-button {
  width: 24px;
  padding: var(--2XS);
}
:deep(.p-button-icon) {
  font-size: 6px;
}
input {
  border: none;
  flex: 1 1 100%;
}
input.quantity-input {
  text-align: center;
}
</style>
